import { Liquid } from 'liquidjs';

export class TemplateService {
    static Init() {
        this.engine = this.GetEngine();
    }

    static GetEngine() {
        this.engine = new Liquid({
            root: '/',
            extname: '.html'          // extension used for layouts/includes (.html) templates
        });

        return this.engine;
    }

    static async GetRenderedTemplate(templateName, data) {

        if (!this.engine) {
            this.Init();
        }

        return await this.engine.renderFile(templateName, data)
    }
}